import { complex, simple } from '@mwl/marker-tree';

export const tournamentsPageSchema = complex({
  wrapper: simple,
  content: simple,
  empty: simple,
  card: simple,
});
